import { createSelector } from 'reselect'

const _getqdUsers = state => {
  return state.users.items.filter(user => {
    return (
      user.roles.includes('qm_editor') ||
      user.roles.includes('qm_quest_manager') ||
      user.roles.includes('qm_mentor_author')
    )
  })
}

const _getActiveQdUsers = state => {
  return state.users.items.filter(user => {
    if (user.active) {
      return (
        user.roles.includes('qm_editor') ||
        user.roles.includes('qm_quest_manager') ||
        user.roles.includes('qm_mentor_author')
      )
    }
  })
}

const _assignableUsers = state => {
  return state.users.items.filter(user => {
    if (user.active) {
      return user.roles.some(
        role =>
          [
            'qm_editor',
            'qm_copy_editor',
            'qm_internal_review',
            'qm_quest_manager',
            'qm_mentor_author'
          ].indexOf(role) > -1
      )
    }
  })
}

const _assignedUsers = state => {
  return state.users.items.filter(user => {
    return user.roles.some(
      role =>
        [
          'qm_editor',
          'qm_copy_editor',
          'qm_internal_review',
          'qm_quest_manager',
          'qm_mentor_author'
        ].indexOf(role) > -1
    )
  })
}

const _getQuestManagers = state => {
  return state.users.items.filter(user => {
    if (user.active) {
      return user.roles.includes('qm_quest_manager')
    }
  })
}

export const getqdUsers = createSelector([_getqdUsers], users => {
  return users
})

export const assignableUsers = createSelector([_assignableUsers], users => {
  return users
})

export const assignedUsers = createSelector([_assignedUsers], users => {
  return users
})

export const questManagers = createSelector([_getQuestManagers], users => {
  return users
})

export const getActiveQdUsers = createSelector([_getActiveQdUsers], users => {
  return users
})



// WEBPACK FOOTER //
// ./src/selectors/users.js